module.exports = __webpack_public_path__ + "media/images/global/icons/staff-a98f6917a08d37df3c2f9ecff2e5faad.svg";